"use client";

import { c as _c } from "react/compiler-runtime";
import React from "react";
function GlobalError(t0) {
  const $ = _c(2);
  const {
    error
  } = t0;
  if (!error?.err) {
    return;
  }
  let t1;
  if ($[0] !== error.message) {
    t1 = <div className="backdrop-blur-2xl rounded-lg py-3 px-4 ring-1 ring-primary ring-opacity-70 text-primary bg-primary bg-opacity-25"><p>{error.message}</p></div>;
    $[0] = error.message;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}
export default GlobalError;